/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DeletePodcastInput = {|
  podcastId: string,
  clientMutationId?: ?string,
|};
export type PodcastListDeleteMutationVariables = {|
  input: DeletePodcastInput
|};
export type PodcastListDeleteMutationResponse = {|
  +deletePodcast: ?{|
    +success: ?boolean
  |}
|};
export type PodcastListDeleteMutation = {|
  variables: PodcastListDeleteMutationVariables,
  response: PodcastListDeleteMutationResponse,
|};
*/


/*
mutation PodcastListDeleteMutation(
  $input: DeletePodcastInput!
) {
  deletePodcast(input: $input) {
    success
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeletePodcastPayload",
    "kind": "LinkedField",
    "name": "deletePodcast",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PodcastListDeleteMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PodcastListDeleteMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "84c3c8ad573029b65f25fcfaa6d9aebd",
    "id": null,
    "metadata": {},
    "name": "PodcastListDeleteMutation",
    "operationKind": "mutation",
    "text": "mutation PodcastListDeleteMutation(\n  $input: DeletePodcastInput!\n) {\n  deletePodcast(input: $input) {\n    success\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'd5c8ed691004e86f9e81914b92f4eed9';

module.exports = node;
